import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasList = ({ children, className, disablePadding, dense, sx, ...props }) => (
  <ul className={cn('flex flex-col', dense ? 'py-0' : !disablePadding ? 'py-2' : '', className)} {...props}>
    {children}
  </ul>
)

AdasList.propTypes = { children: PropTypes.node, className: PropTypes.string, disablePadding: PropTypes.bool, dense: PropTypes.bool }
